import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer style={{ borderTop: '1px solid var(--fs-border)', padding: '40px 20px', background: 'var(--fs-bg)' }}>
      <div style={{
        maxWidth: 'var(--fs-max-width)',
        margin: '0 auto',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 24,
      }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <img src="/src/assets/FORMA-Studio_logo_forma_icon_w.png" alt="FORMA Studio" style={{ height: 24, width: 'auto', opacity: 0.6 }} />
          <span style={{ fontFamily: 'var(--fs-font-headline)', fontWeight: 700, fontSize: 14, color: 'var(--fs-text-muted)' }}>FORMA Studio</span>
        </div>

        {/* Message */}
        <p style={{
          fontFamily: 'var(--fs-font-body)',
          fontSize: 11,
          color: 'var(--fs-text-muted)',
          textAlign: 'center',
          maxWidth: 320,
          lineHeight: 1.6,
        }}>
          FORMA Studio is in public beta. Expect rough edges and report them. Your feedback shapes what gets built next.
        </p>

        {/* Links */}
        <div style={{ display: 'flex', gap: 24 }}>
          {['Privacy', 'Terms', 'Contact'].map(label => (
            <a key={label} href="#" style={{
              fontFamily: 'var(--fs-font-body)',
              fontSize: 11,
              color: 'var(--fs-text-muted)',
              textDecoration: 'none',
              textTransform: 'uppercase',
              letterSpacing: '0.12em',
            }}>{label}</a>
          ))}
        </div>
      </div>

      {/* Copyright */}
      <div style={{
        maxWidth: 'var(--fs-max-width)',
        margin: '24px auto 0',
        paddingTop: 24,
        borderTop: '1px solid var(--fs-border)',
        textAlign: 'center',
      }}>
        <p style={{ fontFamily: 'var(--fs-font-body)', fontSize: 10, color: 'var(--fs-text-muted)', opacity: 0.5 }}>
          © 2026 Frank Ricci Design - FORMA Studio Beta v0.7
        </p>
      </div>
    </footer>
  );
};
